import { render, staticRenderFns } from "./CmsLayout.vue?vue&type=template&id=96a226a8"
import script from "./CmsLayout.vue?vue&type=script&lang=js"
export * from "./CmsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports